<form *ngIf="templateForm" [formGroup]="templateForm" class="content-card">
  <mat-card class="wide-form-card">
    <mat-card-header>
      <mat-card-title>
        <h5>Invoice PDF template</h5>
      </mat-card-title>
    </mat-card-header>
    <mat-card-content>
      <mat-form-field>
        <input matInput placeholder="Template name" formControlName="name" required>
      </mat-form-field>
      <!--  <mat-form-field>
        <input matInput placeholder="Message subject" formControlName="subject" required>
      </mat-form-field> -->

      <div style="margin-bottom: 30px;">
        <button mat-raised-button color="primary" [disabled]="selectedLanguage === 0" (click)="selectLanguage(0)">German</button>
        <button mat-raised-button color="primary" [disabled]="selectedLanguage === 1" (click)="selectLanguage(1)">English</button>
      </div>

      <div class="template-var-group">
        <button *ngFor="let cmd of commands" mat-raised-button class="template-var-item" color="primary" type="button"
          (click)="insert(cmd.name)">{{cmd.title}}</button>
      </div>

      <app-html-editor *ngIf="selectedLanguage == 0" placeholder="Enter message template" formControlName="html" required></app-html-editor>
      <app-html-editor *ngIf="selectedLanguage == 1" placeholder="Enter message template" formControlName="htmlEn" required></app-html-editor>

    </mat-card-content>
    <mat-card-actions align="end">
      <button mat-raised-button color="primary" type="button" (click)="generatePdf()">Download preview</button>
      <div fxFlex></div>
      <a mat-raised-button color="accent" type="button" routerLink="../..">Cancel</a>
      <button mat-raised-button color="primary" type="submit" [disabled]="!templateForm.valid" (click)="onSubmit(templateForm)">Save</button>
    </mat-card-actions>
  </mat-card>
</form>
